import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

export const SignedInRedirectGuard: CanActivateFn = () => {
  const router = inject(Router)

  const role = localStorage.getItem('rol')

  if (role === 'AccessManager') {
    return router.createUrlTree(['/globalConfig/users'])
  }

  return router.createUrlTree(['/dashboard/main'])
}
